export default {"src":"/_next/static/media/taille.a03fce3e.svg","height":64,"width":124,"blurWidth":0,"blurHeight":0};